import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bb84fbb2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "masks"
};
const _hoisted_2 = {
  class: "gesturePwd"
};
const _hoisted_3 = {
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "right": "0",
    "bottom": "0"
  }
};
const _hoisted_4 = {
  ref: "gestureTitle",
  class: "gestureTitle"
};
const _hoisted_5 = {
  ref: "canvas",
  style: {
    "background-color": "#fff",
    "display": "inline-block",
    "margin-top": "76px",
    "width": "320px",
    "height": "320px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h4", _hoisted_4, "请绘制您的图形密码", 512), _createElementVNode("a", {
    ref: "updatePassword",
    style: {
      "position": "absolute",
      "left": "50%",
      "bottom": "30px",
      "transform": "translateX(-50%)",
      "color": "#000",
      "font-size": "13px",
      "display": "block"
    },
    onClick: _cache[0] || (_cache[0] = $event => $options.retPsw())
  }, " 找回密码 ", 512), _createElementVNode("a", {
    ref: "updatePassword",
    style: {
      "position": "absolute",
      "right": "5px",
      "top": "5px",
      "color": "#000",
      "font-size": "13px",
      "display": "block",
      "visibility": "hidden"
    },
    onClick: _cache[1] || (_cache[1] = $event => $options.closePwd())
  }, " 关闭 ", 512), _createElementVNode("canvas", _hoisted_5, null, 512)])])], 512)), [[_vShow, $data.currentValue]]);
}